import { SubscriptionModalProvider } from '../../shared/ui/SubscriptionAccessDialog'
import { lazy, Suspense, useEffect } from 'react'
import {
  NavigationType,
  Outlet,
  ScrollRestoration,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import { PwaInstallPrompt } from '../../platform/pwa/PwaInstallPrompt'
import { RouteToast } from './RouteToast'
import { StoriesIntegration } from './StoriesIntegration'
import { RecommendationAccessProvider } from '../../features/engagement'
import type { StoryNavigationType } from '../../features/engagement'

const ScheduledReviewEntryIntegration = lazy(async () => ({
  default: (await import('./ScheduledReviewEntryIntegration'))
    .ScheduledReviewEntryIntegration,
}))
const noStoryNavigation = () => null
export function RootLayout({
  storyNavigationType = noStoryNavigation,
}: {
  storyNavigationType?: (path: string) => StoryNavigationType
}) {
  const { key: locationKey, pathname } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === NavigationType.Pop || pathname === '/guide') return

    let secondFrame = 0
    const firstFrame = window.requestAnimationFrame(() => {
      window.scrollTo({ left: 0, top: 0 })
      secondFrame = window.requestAnimationFrame(() => {
        window.scrollTo({ left: 0, top: 0 })
      })
    })

    return () => {
      window.cancelAnimationFrame(firstFrame)
      window.cancelAnimationFrame(secondFrame)
    }
  }, [locationKey, navigationType, pathname])

  return (
    <SubscriptionModalProvider>
      <RecommendationAccessProvider>
        <Outlet />
        <ScrollRestoration />
        <PwaInstallPrompt isGuideRoute={pathname === '/ios-pwa'} />
        <StoriesIntegration navigationType={storyNavigationType} />
        <RouteToast />
        <Suspense fallback={null}>
          <ScheduledReviewEntryIntegration />
        </Suspense>
      </RecommendationAccessProvider>
    </SubscriptionModalProvider>
  )
}
